module.exports = __webpack_public_path__ + "static/media/bg-graphic.7fc6f2a6.png";